import { useTranslation } from "next-i18next";
import { cn } from "@/common/utils/css.utils";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import EyeOpenIcon from "@whoppah/icons/24/EyeOpen";
import HeartIcon from "@whoppah/icons/24/line/Heart";

type ProductDetailsInfoActivity = {
  product: ProductBySlugNonNullable;
  className?: string;
};

export const ProductDetailsInfoActivity = ({
  product,
  className = undefined,
}: ProductDetailsInfoActivity) => {
  const { t } = useTranslation();

  return (
    <div className={cn("flex flex-col space-y-2", className)}>
      <span className="flex items-center space-x-4">
        <EyeOpenIcon className="h-5 w-5 text-grey-800" />
        <span className="font-body text-xs text-grey-800 md:text-sm">
          {t("pdp:activity-view-count", { count: product.view_count })}
        </span>
      </span>
      <span className="flex items-center space-x-4">
        <HeartIcon className="h-5 w-5 text-grey-800" />
        <span className="font-body text-xs text-grey-800 md:text-sm">
          {t("pdp:activity-favorite-count", { count: product.favorite_count })}
        </span>
      </span>
    </div>
  );
};
